import { Asset } from "../../interface/Server";
import { LocationBounds, LocationType } from "../../interface/Client";

export interface State {
    markers?: Array<Asset>
    selectedMarker?: Asset, // CustomAssetChild
    mapBounds?: LocationBounds,
    center?: LocationType,
}

export const state: State = {};
export default state;

